import React, {useState} from 'react'
import {makeStyles} from "@material-ui/styles"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Paper from "@material-ui/core/Paper"

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing.unit,
  }
}))

const DetailsTabs = ({tabs = []}) => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState(0)

  return (
    <>
      <Paper square className={classes.container}>
        <Tabs
          value={activeTab}
          onChange={(event, newValue) => setActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
        >
          {tabs.map(tab => (
            <Tab label={tab.title}/>
          ))}
        </Tabs>
      </Paper>

      {tabs.map(({content}, index) => (
        <div role="tabpanel" hidden={activeTab !== index}>
          {content && content()}
        </div>
      ))}
    </>
  )
}

export default DetailsTabs
